  import room1 from "../Assets/omkar-ac-bedroom-1.jpg"
  import swimming1 from "../Assets/omkae-image-1.jpg"
  import swimming2 from "../Assets/omkae-image-2.jpg"
  import swimming4 from "../Assets/nightpool.jpg"
  import swimming9 from "../Assets/omkar-image-9.jpg"
  import swimming10 from "../Assets/omkar-image-10.jpg"
  import activity2 from "../Assets/activity-image-3.jpg"
  import activity3 from "../Assets/activity.jpg"
  import activity5 from "../Assets/activity-5.jpg"
  import activity6 from "../Assets/activityslid.jpg"
  import event1 from "../Assets/eventHoli.jpg"
  import event2 from "../Assets/eventfood.jpg"
  import event3 from "../Assets/eventchild.jpg"
  import event4 from "../Assets/eventwoffel.jpg"


const omkarNature = [
  // ********************************************************************************************
        // {
        //     id: 1,
        //     title: "A/C Room",
        //     category:"room",
        //     imageUr1: room1
            
            
        //   },
        {
            id: 2,
            title: "A/C Room",
            category:"room",
            imageUr1: room1,
            width: 4,
           height: 3,
           
            
            
          },
        // {
        //     id: 3,
        //     title: "A/C Room",
        //     category:"room",
        //     imageUr1: room1           
            
            
        //   },
        // {
        //     id: 4,
        //     title: "A/C Room",
        //     category:"room",
        //     imageUr1: room1           
            
            
        //   },
       
          // ******************************************swimming************************************************************

         

          {
            id:1,
            title: "Swimmingpool",
            category:"Swimmingpool",
            imageUr1: swimming1,
            width: 4,
      height: 3,
          },
          {
            id:2,
            title: "Swimmingpool",
            category:"Swimmingpool",
            imageUr1: swimming4,
            width: 1,
      height: 1,
          },

          {
            id:3,
            title: "Swimmingpool",
            category:"Swimmingpool",
            imageUr1: swimming9,
            width: 3,
            height: 4,
          },
          {
            id:4,
            title: "Swimmingpool",
            category:"Swimmingpool",
            imageUr1: swimming10,
            width: 1,
            height: 2,
            
          },

          // **************************************************event*******************************************************
          {
            id:1,
            title: "Events",
            category:"events",
            imageUr1: event1,
            width: 3,
            height: 4,
            
          },
          {
            id:2,
            title: "Events",
            category:"events",
            imageUr1: event2,
            width: 4,
            height: 3,
          
          },
          {
            id:3,
            title: "Events",
            category:"events",
            imageUr1: event3,
            width: 2,
            height: 2,
          },
          {
            id:4,
            title: "Events",
            category:"events",
            imageUr1:event4,
            width: 4,
            height: 4,
          },
        

          // ***************************************************Activity*************************************************************************
          {
            id:1,
            title: "Activities",
            category:"activity",
            imageUr1: activity3,
            width: 1,
            height: 1,
          },
    
          {
            id:2,
            title: "Activities",
            category:"activity",
            imageUr1:activity2,
            width: 3,
            height: 4,
          },
    
          {
            id:3,
            title: "Activities",
            category:"activity",
            imageUr1:activity5  ,
            width: 3,
            height: 2,
            
          },
          {
            id:4,
            title: "Activities",
            category:"activity",
            imageUr1: activity6,
            width: 3,
            height: 4,
            
          }
    
]
export default omkarNature

  